module.exports = __webpack_public_path__ + "static/img/preview.9e52a31.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects/gillette-vlr-web-development/preview.png
// module id = 93
// module chunks = 2